import { ReactNode } from "react";
import { Navigate, Route } from "react-router-dom";
import { ResourceListPage } from "./components/ResourceListPage";
import { getAllInternalResources } from "./registry";

export function generateInternalResourceRoutes(): ReactNode[] {
  const resources = getAllInternalResources();
  const routes: ReactNode[] = [];

  const sortedResources = [...resources].sort(
    (a, b) => (a.navigation?.order ?? 100) - (b.navigation?.order ?? 100),
  );

  if (sortedResources.length > 0) {
    routes.push(
      <Route
        key="internal-data-index"
        path="/internal/data"
        element={<Navigate to={sortedResources[0].basePath} replace />}
      />,
    );
  }

  for (const resource of resources) {
    routes.push(
      <Route
        key={`${resource.resourceName}-list`}
        path={resource.basePath}
        element={<ResourceListPage config={resource} />}
      />,
    );
  }

  return routes;
}
